import React, { Component } from "react";
import DiagnosticosV2 from "./DiagnosticosV2";
import PacEnConsulta from "./PacEnConsulta";
import AreaResp from "./AreaResp"
import EspConsV2 from "./EspConsV2";
import PersUnidadMed from "./PerUnidadMed";

export default class PanelGeneral extends Component {

  render() {

    const {unidad_medica_user}= this.props;

    return(
      
      unidad_medica_user !== "" &&
        <div className="grid-container-fvg">
          <div className="grid-item-fvg">
            <span className="format-titles-pnl">Personal de la unidad médica</span>  
            <PersUnidadMed {...this.props}/>
          </div>
          <div className="grid-item-fvg-2">
            
            <div className="grid-item-fvg-a">
              
              {/* <span className="format-titles-pnl">No. de pacientes atendidos en consulta</span>   */}
              <PacEnConsulta  {...this.props}/>  
            </div>
            <div className="grid-item-fvg-b">
            {/* <span className="format-titles-pnl">Por área de responsabilidad</span>   */}
              <AreaResp {...this.props}/>
            </div>
                
          </div>
          <div className="grid-item-fvg">
            <span className="format-titles-pnl">Especialidades de la consulta</span>  
            <EspConsV2 {...this.props}/>
          </div>
          <div className="grid-item-fvg">
            
            <span className="format-titles-pnl">Diagnósticos más frecuentes</span>
              <DiagnosticosV2 {...this.props}/>
          </div>
        </div>

      /*
      <div className="hsc-principal-panel-ind-salud">

        <Row type="flex" justify="space-between">
          <Col span={7} className="hsc-pp-col1">
            <Row type="flex" justify="space-between">
              <Col span={11}><TotalConsultas {...this.props}/></Col>
              <Col span={2}/>
              <Col span={11}><DifPorcentaje {...this.props}/></Col>
            </Row>
            
            <Row type="flex" justify="space-between"  className="hsc-pnl-row-container">
              <Col span={24}>
                <div className="hsc-pnl-row-container-title">
                <p className="hsc-pnl-style-titles">Consultas por género</p>
                  <BasicBars {...this.props}/>
                </div>
              </Col>
            </Row>
  
            <Row type="flex" justify="space-between"  className="hsc-pnl-row-container">
              <Col span={24}>
                <div className="hsc-pnl-row-container-title">
                <p className="hsc-pnl-style-titles">Consultas por estado civil</p>
                  <EstadoCivil {...this.props}/>
                </div>
              </Col>
            </Row>
          </Col>
          <Col span={7} className="hsc-pp-col2">
            <Row type="flex" justify="space-between"  className="hsc-pnl-row-container">
              <Col span={24}>
                <div className="hsc-pnl-row-container-title">
                  <p className="hsc-pnl-style-titles">Promedio de medicamentos por consulta</p>
                  <PromMed {...this.props}/>
                </div>
              </Col>
            </Row>
            
            
            <Row type="flex" justify="space-between"  className="hsc-pnl-row-container">
              <Col span={24}>
                <div className="hsc-pnl-row-container-title">                  
                  <CensoEmb {...this.props}/>
                </div>
              </Col>
            </Row>

          </Col>
          <Col span={7} className="hsc-pp-col3">
            <Row type="flex" justify="space-between"  className="hsc-pnl-row-container">
              <Col span={24}>
                <div className="hsc-pnl-row-container-title">
                <p className="hsc-pnl-style-titles">Especialidades de la consulta</p>
                  <EspCons {...this.props}/>
                </div>
              </Col>
            </Row>

            <Row type="flex" justify="space-between"  className="hsc-pnl-row-container">
              <Col span={24}>
                <div className="hsc-pnl-row-container-title">
                <p className="hsc-pnl-style-titles">Motivo de consulta</p>
                  <Diagnosticos {...this.props}/>
                </div>
              </Col>
            </Row>
          </Col>
        </Row> 
      </div>
      */
    );    
  }
}
